import { keyframes } from '@emotion/react';
import Stack from '@zenbusiness/zui/Stack';
import { styled, superstyled } from '@zenbusiness/zui/styles';

export const DialogContentStyle = ({ theme }) => ({
  padding: '40px 0 100px 0',
  backgroundColor: theme.palette.background.grey.main,
  [theme.breakpoints.up('md')]: {
    padding: '60px 0 100px 0'
  }
});

export const FormWrapperStyle = ({ theme }) => ({
  padding: '40px 0 100px 0',
  [theme.breakpoints.up('md')]: {
    padding: '60px 0 100px 0'
  }
});

export const FieldContainerStyle = ({ theme }) => ({
  padding: '16px 24px',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: theme.palette.background.grey.light
});

export const FormControlLabelStyle = () => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0px 5px',
  width: 'fit-content',
  '& .MuiFormControlLabel-label': {
    width: '100%'
  }
});

export const LinkButtonStyle = () => ({
  paddingLeft: '5px!important',
  '& .MuiButton-startIcon': {
    marginRight: '9px'
  },
  '&.Mui-disabled': {
    border: 'none'
  }
});

export const GridStyle = {
  rowGap: '24px'
};

export const RadioGroupStyle = () => ({
  width: 'fit-content',
  gap: '24px'
});

export const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

export const ButtonStyle = () => ({
  '&.Mui-disabled': {
    border: 'none'
  }
});

export const SummaryFormWrapper = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '3 / 11'
  }
});

export const PrintedBoxStyle = () => ({
  '@media print': {
    paddingTop: '12px',
    paddingLeft: '16px',
    paddingRight: '16px'
  }
});

export const SpinnerContainer = superstyled({
  name: 'LoadingSpinner',
  slot: 'Container',
  styles: {
    alignSelf: 'stretch',
    justifySelf: 'stretch',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center'
  }
});

// Define keyframes
export const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

// Define the animation styles
export const stepItemStyles = {
  animationName: fadeIn,
  animationDuration: '1s',
  animationFillMode: 'both'
};

export const StepItemStyle = styled(Stack)(() => ({
  animationName: fadeIn,
  animationDuration: stepItemStyles.animationDuration,
  animationFillMode: stepItemStyles.animationFillMode,
  WebkitAnimationName: fadeIn,
  WebkitAnimationDuration: stepItemStyles.animationDuration,
  WebkitAnimationFillMode: stepItemStyles.animationFillMode
}));
